'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

exports.first = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iterator) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(iterator);

          case 4:
            _context.next = 6;
            return _iterator.next();

          case 6:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 10;
            return _step.value;

          case 10:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 17;
              break;
            }

            value = _value;
            return _context.abrupt("return", value);

          case 14:
            _iteratorNormalCompletion = true;
            _context.next = 4;
            break;

          case 17:
            _context.next = 23;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 23:
            _context.prev = 23;
            _context.prev = 24;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 28;
              break;
            }

            _context.next = 28;
            return _iterator.return();

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(23);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 19, 23, 33], [24,, 28, 32]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.last = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(iterator) {
    var value, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context2.prev = 2;
            _iterator2 = _asyncIterator(iterator);

          case 4:
            _context2.next = 6;
            return _iterator2.next();

          case 6:
            _step2 = _context2.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context2.next = 10;
            return _step2.value;

          case 10:
            _value2 = _context2.sent;

            if (_iteratorNormalCompletion2) {
              _context2.next = 16;
              break;
            }

            value = _value2;

          case 13:
            _iteratorNormalCompletion2 = true;
            _context2.next = 4;
            break;

          case 16:
            _context2.next = 22;
            break;

          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](2);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 22:
            _context2.prev = 22;
            _context2.prev = 23;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context2.next = 27;
              break;
            }

            _context2.next = 27;
            return _iterator2.return();

          case 27:
            _context2.prev = 27;

            if (!_didIteratorError2) {
              _context2.next = 30;
              break;
            }

            throw _iteratorError2;

          case 30:
            return _context2.finish(27);

          case 31:
            return _context2.finish(22);

          case 32:
            return _context2.abrupt("return", value);

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 18, 22, 32], [23,, 27, 31]]);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.all = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(iterator) {
    var values, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, value;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            values = [];
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _context3.prev = 3;
            _iterator3 = _asyncIterator(iterator);

          case 5:
            _context3.next = 7;
            return _iterator3.next();

          case 7:
            _step3 = _context3.sent;
            _iteratorNormalCompletion3 = _step3.done;
            _context3.next = 11;
            return _step3.value;

          case 11:
            _value3 = _context3.sent;

            if (_iteratorNormalCompletion3) {
              _context3.next = 18;
              break;
            }

            value = _value3;
            values.push(value);

          case 15:
            _iteratorNormalCompletion3 = true;
            _context3.next = 5;
            break;

          case 18:
            _context3.next = 24;
            break;

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](3);
            _didIteratorError3 = true;
            _iteratorError3 = _context3.t0;

          case 24:
            _context3.prev = 24;
            _context3.prev = 25;

            if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
              _context3.next = 29;
              break;
            }

            _context3.next = 29;
            return _iterator3.return();

          case 29:
            _context3.prev = 29;

            if (!_didIteratorError3) {
              _context3.next = 32;
              break;
            }

            throw _iteratorError3;

          case 32:
            return _context3.finish(29);

          case 33:
            return _context3.finish(24);

          case 34:
            return _context3.abrupt("return", values);

          case 35:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 20, 24, 34], [25,, 29, 33]]);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.extendIterator = function (iterator) {
  iterator.first = function () {
    return exports.first(iterator);
  };

  iterator.last = function () {
    return exports.last(iterator);
  };

  iterator.all = function () {
    return exports.all(iterator);
  };

  return iterator;
};